import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06eee789"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "book-wrapper" }
const _hoisted_2 = { class: "book bound" }
const _hoisted_3 = { class: "pages" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page flipped" }, null, -1))
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

import { sleep } from '@/utils'
import {
  withDefaults,
  reactive,
  onMounted,
  onUnmounted,
  toRefs,
  watch,
} from 'vue'

interface Props {
  firstPage: {
    backgroundImage: string
    title: string
    count: number
    unit: string
  }
  secondPage: {
    backgroundImage: string
    title: string
    count: number
    unit: string
  }
  loaded: boolean
}

type ElementsHalfWidthType = keyof typeof elementsHalfWidth


export default /*#__PURE__*/_defineComponent({
  __name: 'ReadBookStatus',
  props: {
    firstPage: { default: () => ({
    backgroundImage: require('@/assets/image/top/book_pages.svg'),
    title: '',
    count: 0,
    unit: '',
  }) },
    secondPage: { default: () => ({
    backgroundImage: require('@/assets/image/top/book_books.svg'),
    title: '',
    count: 0,
    unit: '',
  }) },
    loaded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { firstPage: {
    backgroundImage: string
    title: string
    count: number
    unit: string
  }, secondPage: {
    backgroundImage: string
    title: string
    count: number
    unit: string
  }, loaded: boolean }

/**
 * ReadBookStatus.
 *
 * 読書ステータス.
 */



const elementsHalfWidth = reactive({
  firstPageTitle: '',
  firstPageCount: '',
  firstPageUnit: '',
  secondPageTitle: '',
  secondPageCount: '',
  secondPageUnit: '',
})
let nextFlip: 'prev' | 'next' = 'prev'

// 自動でページをめくるクロージャー
const flipper = (() => {
  const interval = 60000
  let intervalId: number

  const once = () => {
    executeFlip()
  }

  const start = () => {
    intervalId = window.setInterval(() => {
      executeFlip()
    }, interval)
  }

  const stop = () => clearInterval(intervalId)

  return {
    once,
    start,
    stop,
  }
})()

// ローディング完了を監視
const { loaded } = toRefs(props)
watch(loaded, async () => {
  // アニメーション分を待つ
  await sleep(300)
  flipper.once()
})

onMounted(() => {
  init()
  flipper.start()
})

onUnmounted(() => {
  flipper.stop()
})

/**
 * observeResize.
 *
 * 本に表示しているテキストのDOMの幅の半分をセット.
 *
 * @param {ElementsHalfWidthType} type
 * @returns {ResizeObserver} observer
 */
const observeResize = (type: ElementsHalfWidthType): ResizeObserver => {
  const el = document.querySelector(`[data-observe=${type}]`)

  if (!el) {
    throw Error(`[data-observe=${type}] element not found.`)
  }

  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      let width: number

      if (entry.contentBoxSize) {
        // Firefox implements `contentBoxSize` as a single content rect, rather than an array
        const contentBoxSize = Array.isArray(entry.contentBoxSize)
          ? entry.contentBoxSize[0]
          : entry.contentBoxSize

        width = contentBoxSize.inlineSize
      } else {
        width = entry.contentRect.width
      }

      elementsHalfWidth[type] = `${width / 2}px`
    }
  })

  observer.observe(el)

  return observer
}

/**
 * init.
 */
const init = async (): Promise<undefined> => {
  // 本に表示しているテキストのDOMの幅を監視
  observeResize('firstPageTitle')
  observeResize('firstPageCount')
  observeResize('firstPageUnit')
  observeResize('secondPageTitle')
  observeResize('secondPageCount')
  observeResize('secondPageUnit')

  // z-index調整
  const pages = document.querySelectorAll('.page')

  if (!pages) return

  pages.forEach((page, i) => {
    if (i % 2 === 0) {
      ;(page as HTMLElement).style.zIndex = String(pages.length - i)
    }
  })
}

/**
 * executeFlip.
 */
const executeFlip = () => {
  const pageEl = document.querySelector(`[data-flip="${nextFlip}"]`)

  if (pageEl instanceof HTMLElement) {
    nextFlip = nextFlip === 'prev' ? 'next' : 'prev'
    flip(pageEl)
  }
}

let timerId: number

/**
 * flip.
 *
 * @param {HTMLElement} pageEl
 */
const flip = (pageEl: HTMLElement): void => {
  flipper.stop()

  const animationDuration = 1400
  clearTimeout(timerId)
  timerId = window.setTimeout(() => {
    flipper.start()
  }, animationDuration)

  const pages = document.querySelector('.pages')?.children
  const page = pageEl

  if (!pages || !page) return

  const pageNum = [...pages].indexOf(page) + 1

  if (pageNum % 2 === 0) {
    page.classList.remove('flipped')
    page.previousElementSibling?.classList.remove('flipped')
  } else {
    page.classList.add('flipped')
    page.nextElementSibling?.classList.add('flipped')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "page flipped",
            style: _normalizeStyle({
              backgroundImage: `url(${__props.firstPage.backgroundImage})`,
            }),
            onClick: executeFlip
          }, [
            _createElementVNode("span", {
              "data-observe": "firstPageTitle",
              class: "text text--head-left-pages",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.firstPageTitle}`,
              }),
              innerHTML: __props.firstPage.title
            }, null, 12, _hoisted_5),
            _createElementVNode("span", {
              "data-observe": "firstPageCount",
              class: "text text--num-left",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.firstPageCount}`,
              })
            }, _toDisplayString(__props.firstPage.count), 5),
            _createElementVNode("span", {
              "data-observe": "firstPageUnit",
              class: "text text--foot-left-pages",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.firstPageUnit}`,
              })
            }, _toDisplayString(__props.firstPage.unit), 5)
          ], 4),
          _createElementVNode("div", {
            class: "page flipped with-page-flip-right",
            "data-flip": "next",
            style: _normalizeStyle({
              backgroundImage: `url(${__props.firstPage.backgroundImage})`,
            }),
            onClick: executeFlip
          }, [
            _createElementVNode("span", {
              class: "text text--head-right-pages",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.firstPageTitle}`,
              }),
              innerHTML: __props.firstPage.title
            }, null, 12, _hoisted_6),
            _hoisted_7,
            _createElementVNode("span", {
              class: "text text--num-right",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.firstPageCount}`,
              })
            }, _toDisplayString(__props.firstPage.count), 5),
            _createElementVNode("span", {
              class: "text text--foot-right-pages",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.firstPageUnit}`,
              })
            }, _toDisplayString(__props.firstPage.unit), 5)
          ], 4),
          _createElementVNode("div", {
            class: "page flipped with-page-flip-left",
            "data-flip": "prev",
            style: _normalizeStyle({
              backgroundImage: `url(${__props.secondPage.backgroundImage})`,
            }),
            onClick: executeFlip
          }, [
            _createElementVNode("span", {
              "data-observe": "secondPageTitle",
              class: "text text--head-left-books",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.secondPageTitle}`,
              }),
              innerHTML: __props.secondPage.title
            }, null, 12, _hoisted_8),
            _createElementVNode("span", {
              "data-observe": "secondPageCount",
              class: "text text--num-left",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.secondPageCount}`,
              })
            }, _toDisplayString(__props.secondPage.count), 5),
            _createElementVNode("span", {
              "data-observe": "secondPageUnit",
              class: "text text--foot-left-books",
              style: _normalizeStyle({
                right: `-${elementsHalfWidth.secondPageUnit}`,
              })
            }, _toDisplayString(__props.secondPage.unit), 5)
          ], 4),
          _createElementVNode("div", {
            class: "page",
            style: _normalizeStyle({
              backgroundImage: `url(${__props.secondPage.backgroundImage})`,
            }),
            onClick: executeFlip
          }, [
            _createElementVNode("span", {
              class: "text text--head-right-books",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.secondPageTitle}`,
              }),
              innerHTML: __props.secondPage.title
            }, null, 12, _hoisted_9),
            _createElementVNode("span", {
              class: "text text--num-right",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.secondPageCount}`,
              })
            }, _toDisplayString(__props.secondPage.count), 5),
            _createElementVNode("span", {
              class: "text text--foot-right-books",
              style: _normalizeStyle({
                left: `-${elementsHalfWidth.secondPageUnit}`,
              })
            }, _toDisplayString(__props.secondPage.unit), 5)
          ], 4)
        ])
      ])
    ])
  ]))
}
}

})